module.exports = __webpack_public_path__ + "img/WAPPR_ORANGE.60c2eb25.svg";